import {
  AspectRatio,
  VideoDimensionsHeight,
  VideoDimensionsWidth,
} from '@src/types.ts/video';

type Dimensions = { width: number; height: number };

const DEFAULT_DIMENSIONS: Dimensions = {
  width: VideoDimensionsWidth.AR_16_9,
  height: VideoDimensionsHeight.AR_16_9,
};

/**
 * Returns the standard 720p-based dimensions for a given aspect ratio.
 *
 * All internal video editing operations assume a 720p coordinate system.
 * Without normalizing to these dimensions, videos at non-standard resolutions
 * (e.g. 4K at 3840×2160) cause px→vh caption conversions to use the wrong
 * denominator, making captions appear incorrectly sized.
 *
 * Unrecognized aspect ratios fall back to 16:9 (1280×720).
 */
export function getStandardDimensionsForAspectRatio(
  aspectRatio: AspectRatio,
): Dimensions {
  switch (aspectRatio) {
    case AspectRatio.AR_16_9:
      return {
        width: VideoDimensionsWidth.AR_16_9,
        height: VideoDimensionsHeight.AR_16_9,
      };
    case AspectRatio.AR_9_16:
      return {
        width: VideoDimensionsHeight.AR_16_9 * (9 / 16),
        height: VideoDimensionsHeight.AR_16_9,
      };
    case AspectRatio.AR_1_1:
      return {
        width: VideoDimensionsHeight.AR_16_9,
        height: VideoDimensionsHeight.AR_16_9,
      };
    default:
      return DEFAULT_DIMENSIONS;
  }
}
